import React from "react";

const Plugin = () => {
  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.title}>⚙️ Under Maintenance</h1>
        <p style={styles.text}>
          This page is currently under maintenance.
          Please come back later.
        </p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#0f172a", // dark background
  },
  card: {
    padding: "40px",
    borderRadius: "12px",
    backgroundColor: "#1e293b", // dark card
    boxShadow: "0 4px 15px rgba(0,0,0,0.6)",
    textAlign: "center",
  },
  title: {
    marginBottom: "15px",
    color: "#38bdf8", // light blue
  },
  text: {
    color: "#cbd5e1", // light gray
  },
};

export default Plugin;